// extracted by mini-css-extract-plugin
module.exports = {"title":"PartnersCyHero_title____Ry3"};